import * as React from 'react';
import * as PropTypes from 'prop-types';

import Modal from '../../../components/Modal';
import { default as EditCheckForm } from './EditCheckForm';
import { PopupLoading } from './PopupLoading';

export class EditCheckPopup extends React.Component {
  static propTypes = {
    record: PropTypes.object,
    inProcess: PropTypes.bool,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const { onOk, onCancel } = this.props;

    return (
      <Modal showModal={true} hasCloseIcon={false} type={'small'}>
        {this.props.inProcess && <PopupLoading />}

        <h2>{'Редактировать чек'}</h2>

        <EditCheckForm initialValues={this.props.record} onOk={onOk} onCancel={onCancel} />
      </Modal>
    );
  }
}
